/**
 * Minimal port of legacy `dateUtils` — only the helpers HALO touches.
 */
import { formatInTimeZone } from 'date-fns-tz';

export function formatDateMmddyy(timestamp: number | string | Date): string {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yy = String(date.getFullYear()).slice(-2);
  return `${mm}/${dd}/${yy}`;
}

export function parseISODateString(
  dateTimeISO: string,
  zoneId = 'UTC',
  pattern = '',
): Date | string {
  const date = new Date(dateTimeISO);
  if (!pattern) return date;
  return formatInTimeZone(date, zoneId || 'UTC', pattern);
}

export function isDaylightSavings(dateISOString = ''): boolean {
  const date = dateISOString
    ? new Date(dateISOString.includes('T') ? dateISOString : `${dateISOString}T12:00:00Z`)
    : new Date();
  const winterDate = new Date(date.getFullYear(), 0, 1);
  return date.getTimezoneOffset() !== winterDate.getTimezoneOffset();
}

export function appendTimeISOSubstringIfMissing(dateISOString = ''): string {
  if (!dateISOString || dateISOString.includes('T')) {
    return dateISOString;
  }

  const highNoonETasUTC = isDaylightSavings(dateISOString)
    ? 'T16:00:00Z'
    : 'T17:00:00Z';
  return `${dateISOString}${highNoonETasUTC}`;
}

export function removeTimeISOSubstring(dateISOString = ''): string {
  return dateISOString.split('T')[0];
}

export function isDateInThePast(date: string | Date): boolean {
  return new Date() > new Date(date);
}

const dateUtils = {
  appendTimeISOSubstringIfMissing,
  formatDateMmddyy,
  isDateInThePast,
  parseISODateString,
  removeTimeISOSubstring,
};

export default dateUtils;
